import type {ReactElement} from 'react';
import React from 'react';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import {BorderType} from '@PosterWhiteboard/classes/item-border.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromBorderOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromBorderOfActiveItem';

export function ItemBorderColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemBorderType = useGetKeyFromBorderOfActiveItem('solidBorderType');
  const activeItemBorderColor = useGetKeyFromBorderOfActiveItem('solidBorderColor');

  if (!activeItem || (activeItem && !('border' in activeItem)) || activeItemBorderType === undefined || !activeItemBorderColor) {
    throw new Error(`Item doesn't have border property`);
  }

  const getBorderColor = (): ColorStorage[] => {
    return [
      {
        id: 'primary',
        color: activeItemBorderColor,
      },
    ];
  };

  const updateBorder = (solidBorderColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        border: {
          solidBorderColor,
        },
      },
      {undoable}
    );
  };

  const onChangeBorderColor = (updatedColor: ColorStorage[]): void => {
    updateBorder(updatedColor[0].color, false);
  };

  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    updateBorder(updatedColor[0].color);
  };

  return (
    <PosterEditingBaseColorPanel
      id="item-border-color-panel"
      isGradientEnabled={false}
      color={getBorderColor()}
      onChangeColor={onChangeBorderColor}
      onChangeEnded={onChangeColorEnded}
      addDelayToOnChangeColor={activeItemBorderType === BorderType.STROKE_BORDER}
    />
  );
}
